import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import HeaderOne from "../../components/layout/HeaderOne";
import Breadcrumb from "../../components/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import Contact from "../../components/Contact";
import ScrollToTop from "react-scroll-to-top";
const ContactPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Contact Us"} />

      {/* Contact */}
      <Contact />

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ContactPage;
